import Vue from "vue";
import Vuex from "vuex";
import agendalistInitial from "./modules/agendalistInitial";

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        agendalistInitial
    }
});